<template><span
    class="boat-navigation__link"
    :class="{_current: props.name === props.active}"
    @click.stop.prevent="click_scrollTo(props.name)"
    >
        <component
            :is="icon_comp(name)"
            class="boat-navigation__icon"
        />
    <slot>Название</slot>
</span></template>

<script setup>
import vPath from '@/assets/vicons/path.vue'
import vDescription from '@/assets/vicons/description.vue'
import vShip from '@/assets/vicons/shipfigma.vue'
import vSale from '@/assets/vicons/sale.vue'
import vRooms from '@/assets/vicons/rooms.vue'
import DefaultIcon from '@/assets/vicons/seal-warning.vue' // Вначале пункт, потом иконку

import { NAV_DICT, click_scrollTo  } from  './NAV.js'

const props = defineProps({
    name: {},
    cruise_link_anchor: {
        type: Function,
    },
    active: {
        type: String,
    }
})

const ICONS = { 
    Route: vPath,
    Overview: vDescription,
    Ship: vShip,
    Promotions: vSale,
    Cabins: vRooms,
}

const icon_comp = (name) => {
    return name in ICONS ? ICONS[name] : DefaultIcon
}

</script>